var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    fill: "current",
    viewBox: "0 0 15.7 14",
    style: {
      enableBackground: "new 0 0 15.7 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5,3.3c0-0.2-0.1-0.3-0.2-0.5L7.6,0.2C7.5,0.1,7.3,0,7.2,0H7v3.5h3.5V3.3z M15.6,8.4L13,5.8 c-0.3-0.3-0.8-0.1-0.8,0.3v1.8h-1.8v1.8h1.8v1.8c0,0.4,0.5,0.6,0.8,0.3l2.6-2.7C15.8,8.9,15.8,8.6,15.6,8.4z M5.2,9.2V8.3 c0-0.2,0.2-0.4,0.4-0.4h4.8V4.4H6.8c-0.4,0-0.7-0.3-0.7-0.7V0H0.7C0.3,0,0,0.3,0,0.7v12.7C0,13.7,0.3,14,0.7,14h9.2 c0.4,0,0.7-0.3,0.7-0.7V9.6H5.7C5.4,9.6,5.2,9.4,5.2,9.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.d5df90075956b5934ae76b68628344e1.svg";
export { ForwardRef as ReactComponent };